import { render, staticRenderFns } from "./CncTabMenu.vue?vue&type=template&id=80b7e728"
import script from "./CncTabMenu.vue?vue&type=script&lang=js"
export * from "./CncTabMenu.vue?vue&type=script&lang=js"
import style0 from "./CncTabMenu.vue?vue&type=style&index=0&id=80b7e728&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports